import { participantConstants } from '../_constants';

//-- add School
export function addParticipant(state = {}, action) {
  switch (action.type) {
    case participantConstants.PARTICIPANT_ADDED_REQUEST:
      return {
        addParticipant: false
      };

    case participantConstants.PARTICIPANT_ADDED_SUCCESS:
      //console.log("ASC ", action.user);
      return { addParticipant:action.successAction};

    case participantConstants.PARTICIPANT_ADDED_FAILURE:
      return {
        addParticipant: false,
      };

    default:
      return state
  }
}


//-- get coupons list
export function getParticipantsList(state = {}, action) {
  switch (action.type) {
    case participantConstants.PARTICIPANT_LIST_REQUEST:
      return {
        getParticipantsList: false
      };

    case participantConstants.PARTICIPANT_LIST_SUCCESS:
      return { getParticipantsList:action.successAction};

    case participantConstants.PARTICIPANT_LIST_FAILURE:
      return {
        getParticipantsList: false,
      };

    default:
      return state
  }
}

//-- save the list of Contest
export function saveParticipant(state = {}, action) {
  switch (action.type) {
    case participantConstants.PARTICIPANT_ADDED_REQUEST:
      return {
        savedSchool: false
      };

    case participantConstants.PARTICIPANT_ADDED_SUCCESS:
      //console.log("REDUCER ", action);
      return { savedSchool: action.successAction };

    case participantConstants.PARTICIPANT_ADDED_FAILURE:
      return {
        savedSchool: false,
      };

    default:
      return state
  }
}

//-- delete the Contest
export function deleteParticipant(state = {}, action) {
  switch (action.type) {
    case participantConstants.DELETE_PARTICIPANT_REQUEST:
      return {
        deleteParticipant: false
      };

    case participantConstants.DELETE_PARTICIPANT_SUCCESS:
      //console.log("REDUCER ", action);
      return { deleteParticipant: action.successAction };

    case participantConstants.DELETE_PARTICIPANT_FAILURE:
      return {
        deleteParticipant: false,
      };

    default:
      return state
  }
}

// Get specific category by id
export function getParticipant(state = {}, action) {
  switch (action.type) {
    case participantConstants.PARTICIPANT_BY_ID_REQUEST:
      return {
        editParticipantData: false
      };

    case participantConstants.PARTICIPANT_BY_ID_SUCCESS:
      //console.log("ASC ", action.user);
      return { editParticipantData:action.successAction};

    case participantConstants.PARTICIPANT_BY_ID_FAILURE:
      return {
        editParticipantData: false,
      };

    default:
      return state
  }
}